const theme = {
  palette: {
    // primary: '#2C3546',
    primary: '#4487F8',
    lightPrimary: '#4cb1e8',
    secondary: '#244496',
    loadingBackgroundColor: '#2c3e51cc',
    color: ['#e64c38', '#06AEBA', '#f8b51d'],
    dark: '#000444',
  },
  fonts: {
    primary: 'Poppins',
  },
  fontWeight: {
    thin: 100, // Thin
    utraLight: 200, // Ultra Light
    light: 300, // Light
    regular: 400, // Regular
    medium: 500, // Medium
    semibold: 600, // Semibold
    bold: 600, // Bold
    heavy: 800, // Heavy
    black: 900, // Black
  },
  background: {
    primary: '#06AEBA',
    warning: '#f8b51d',
    error: '#ed1558',
    content: '#fff',
    container: '#f4f7f9',
    input: '#F6F6F6',
    disabled: '#969696',
    headerTable: '#ffff',
    headerFormTable: '#f6f6f6',
    gray: '#f0f0f0',
    light: '#e4e7eb',
  },
  text: {
    // primary: '#1f2933',
    primary: '#4487F8',
    btnPrimaryColor: '#fff',
    text: '#1f2933',
    lightPrimary: '#3e4c59',
    secondary: '#888888',
    tabTitle: '#7f817c',
    empty: '#969696',
    highlight: '#4487F8',
    disabled: '#969696',
    formLabel: '#1f2933',
    headerTable: '#2C3546',
    note: '#878787',
    formIcon: '#41433f',
  },
  border: {
    default: '#dddddd',
    light: '#e4e7eb',
    primary: '#06AEBA',
  },
  borderRadius: {
    button: '6px',
  },
  scrollbar: {
    thumb: '#b7b6c2',
    track: '#f0f3fa',
  },
  color: {
    gray: '#a3a3a3',
    green: '#4fcea2',
    brightGreen: '#52c41a',
    red: '#e64c38',
    blue: '#0992d0',
    orange: '#f5a623',
    darkOrange: '#E86500',
    pink: '#F75D81',
    limeGreen: '#4fcea2',
    lightGreen: '#3ebac2',
    blueShade: '#2d7fd3',
    yellow: '#FFCA28',
    violet: '#665ca7',
    purple: '#ac009f',
    darkSlateBlue: '#483D8B',
  },
  alert: {
    error: 'red',
  },
  card: {
    header: '#d4d2f450',
  },
  sidebar: {
    activeText: 'white',
    activeBG: '#06AEBA',
  },
  drawer: {
    headerTitle: '#0f100d',
    closeIcon: '#91938e',
  },
  table: {
    headerBackground: '#fff',
    headerColor: '#50649c',
    color: '#7286a2',
  },
};
module.exports = theme;
